import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useReveal from "../useReveal";
import "./Style.scss";

const features = [
  {
    icon: "fa-microchip",
    title: "Technology",
    text: "Reliable trading technology with the power and mobility you expect.",
  },
  {
    icon: "fa-box-open",
    title: "Products",
    text: "A focused product kit tailored to how you trade and invest.",
  },
  {
    icon: "fa-id-card",
    title: "Accounts",
    text: "Paperless account opening — complete your forms online with ease.",
  },
  {
    icon: "fa-tags",
    title: "Pricing",
    text: "Brokerage plans that suit your goals with clearer margins.",
  },
];

const Why = () => {
  const revealRef = useReveal();

  return (
    <section className="homeWhy">
      <Container className="homeWhy__inner homeReveal" ref={revealRef}>
        <div className="homeWhy__intro">
          <h2>Why Algoquant Global?</h2>
          <p>
            Whether you are new to the markets or an active trader, get reliable
            trading technology, transparent brokerage, and a smooth digital
            account experience under one roof.
          </p>
        </div>
        <Row className="g-3 g-md-4 homeWhy__grid">
          {features.map((item) => (
            <Col md={6} key={item.title}>
              <article className="homeWhy__item">
                <span className="homeWhy__icon" aria-hidden="true">
                  <i className={`fas ${item.icon}`} />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            </Col>
          ))}
        </Row>
        <div className="homeWhy__cta">
          <Link to="/step-by-step" className="homeCtaPrimary">
            Open a Trading Account
            <i className="fas fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default Why;
